import { Injectable, Injector } from '@angular/core'
import { Router } from '@angular/router'

import { StoreService } from '@core/store.service'

import { ActivatedRoute } from '@angular/router'
///import 'rxjs/add/operator/map';

@Injectable()
export class NavigatorService {
   console: boolean = false
   logPrefix: string = '@core - ' + this.constructor.name

   public previousRoute: string = ''
   public currentRoute: string
   //private redirectRoute: string;

   // public route: ActivatedRoute;

   constructor(
      private store: StoreService,
      private router: Router,
      public route: ActivatedRoute,
      private injector: Injector
   ) {}

   refreshParams() {
      if (this.console) console.log(this.logPrefix, 'refreshParams', this.router)

      this.previousRoute = this.currentRoute

      if (this.console) console.log(this.logPrefix, 'refreshParams - previousRoute:', this.previousRoute)

      //this.currentRoute = '/'+this.router.url.split('/')[1];

      let urlSplit = this.router.url.split('/')
      urlSplit.shift()

      let routeParts = []
      for (let part of urlSplit) {
         if (!isNaN(part as any)) {
            //is numeric
            break
         }
         routeParts.push(part)
      }

      this.currentRoute = '/' + routeParts.join('/')

      if (this.console) console.log(this.logPrefix, 'refreshParams - currentRoute:', this.currentRoute)
   }

   //-- Navigation --//

   goToRoute(route: string, queryParams?: any) {
      if (this.console) console.log(this.logPrefix, 'goToRoute:', route)

      if (!route) route = ''

      this.router.routeReuseStrategy.shouldReuseRoute = function () {
         return false
      }

      //this._router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload'

      if (!queryParams) {
         this.router.navigate([route]) // redirect
      } else {
         this.router.navigate([route, queryParams]) // redirect
      }
   }

   getCurrentRoute() {
      return this.currentRoute
   }
}

